import { Link, NavLink, useNavigate } from "react-router-dom";

/* ─── Bottom Nav Item ─── */
function BottomNavItem({ to, icon, activeIcon, label }) {
  return (
    <NavLink
      to={to}
      className="bottom-nav-item"
      style={({ isActive }) => ({ "--active": isActive ? 1 : 0 })}
    >
      {({ isActive }) => (
        <>
          <span className="bottom-nav-icon">
            <i className={`bi ${isActive ? activeIcon : icon}`} />
          </span>
          <span className="bottom-nav-label">{label}</span>
        </>
      )}
    </NavLink>
  );
}

function Header() {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    navigate("/", { replace: true });
  };

  const navItems = [
    {
      to: "/dashboard",
      icon: "bi-grid",
      activeIcon: "bi-grid-fill",
      label: "Dashboard",
    },
    {
      to: "/products",
      icon: "bi-bag",
      activeIcon: "bi-bag-fill",
      label: "Products",
    },
    {
      to: "/network",
      icon: "bi-diagram-3",
      activeIcon: "bi-diagram-3-fill",
      label: "Network",
    },
    {
      to: "/orders",
      icon: "bi-receipt",
      activeIcon: "bi-receipt",
      label: "Orders",
    },
  ];

  return (
    <>
      <style>{`
        /* ── Each Item ── */
        .bottom-nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          gap: 3px;
          text-decoration: none;
          padding: 8px 4px 6px;
          border-radius: 50px;
          position: relative;
          transition: background 0.2s;
          -webkit-tap-highlight-color: transparent;
        }

        /* Active background pill */
        .bottom-nav-item[style*="--active: 1"] {
          background: rgba(0, 0, 0, 0.06);
        }

        /* ── Icon wrapper ── */
        .bottom-nav-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 18px;
        }

        .bottom-nav-icon .bi {
          font-size: 20px;
          line-height: 1;
          transition: color 0.2s, transform 0.25s cubic-bezier(.34,1.56,.64,1);
          color: rgba(0, 0, 0, 0.38);
        }

        /* active icon styles */
        .bottom-nav-item[style*="--active: 1"] .bottom-nav-icon .bi {
          color: #000000;
          transform: translateY(-2px) scale(1.12);
        }


        /* ── Label ── */
        .bottom-nav-label {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.02em;
          font-family: 'DM Sans', sans-serif;
          transition: color 0.2s;
          color: rgba(0, 0, 0, 0.38);
          white-space: nowrap;
        }

        .bottom-nav-item[style*="--active: 1"] .bottom-nav-label {
          color: #000000;
        }

        /* ── Press feedback ── */
        .bottom-nav-item:active .bottom-nav-icon .bi {
          transform: scale(0.88);
        }
      `}</style>

      {/* ── Top Header ── */}
      <div className="sticky-top">
        <div className="container pt-2">
          <div className="navbar navbar-expand-lg py-1 px-1 border-0 shadow-none rounded-pill z-5 my-header-bg">
            <Link to="/">
              <img src="/assets/images/icon.png" width="48" className="me-5" />
            </Link>
            <div className="ms-auto d-flex align-items-center order-lg-3">
              <div className="d-flex align-items-center">
                <div className="d-flex gap-1 align-items-center justify-content-end me-lg-5 me-2">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/assets/images/facebook.png" width="30" />
                  </a>
                  <img src="/assets/images/instagram.png" width="30" />
                  <a href="https://x.com/" target="_blank" rel="noreferrer">
                    <img src="/assets/images/x.png" width="30" />
                  </a>
                  <a
                    href="https://www.youtube.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/assets/images/youtube.png" width="30" />
                  </a>
                </div>
                <Link
                  to="/notifications"
                  className="nav-link d-lg-none d-block"
                >
                  <i className="bi bi-bell-fill text-danger align-middle ms-4 fs-3"></i>
                </Link>
                <Link
                  to="/cart"
                  className="btn btn-icon btn-dark rounded-circle ms-3 me-1"
                >
                  <i className="bi bi-cart align-middle"></i>
                </Link>
                <div
                  onClick={handleLogout}
                  className="btn btn-icon btn-danger rounded-circle me-1"
                >
                  <i className="bi bi-power align-middle"></i>
                </div>
              </div>
            </div>

            {/* Desktop nav */}
            <div className="collapse navbar-collapse" id="navbar-default">
              <ul className="navbar-nav mt-3 mt-lg-0 ms-lg-2">
                <li className="nav-item">
                  <NavLink to="/dashboard" className="nav-link ps-0">
                    Dashboard
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/products" className="nav-link">
                    Products
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/network" className="nav-link">
                    Referral Network / History
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/orders" className="nav-link">
                    Order History
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/notifications" className="nav-link">
                    Notifications
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="d-lg-none d-block">
        <div className="fixed-bottom">
          <div className="container">
            <div className="d-flex py-1 px-1 border-0 shadow-none rounded-pill z-5 my-header-bg bg-white mb-2">
              {navItems.map((item) => (
                <BottomNavItem key={item.to} {...item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
